(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["additional-projects"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {

  const slider = document.querySelector("#additional-projects-slider");

  // CASE: manual blocks exist → Slick already runs → STOP
  if (slider.children.length > 0) {
    console.log("Manual blocks found — fallback disabled.");
    return;
  }

  // -------------------------------
  // AUTO LOAD MODE (NO MANUAL BLOCKS)
  // -------------------------------

  const currentPage = window.location.pathname;

  fetch("/pages/projects")
    .then(res => res.text())
    .then(html => {

      const doc = new DOMParser().parseFromString(html, "text/html");
      const scriptTag = doc.querySelector("#featured-projects-master");
      if (!scriptTag) return;

      let projects = JSON.parse(scriptTag.textContent.trim());

      // REMOVE CURRENT PROJECT
      projects = projects.filter(p => p.link !== currentPage);

      // SHUFFLE (no duplicates)
      for (let i = projects.length - 1; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1));
        [projects[i], projects[j]] = [projects[j], projects[i]];
      }

      // GET FIRST 3 UNIQUE PROJECTS
      let fallback = projects.slice(0, 3);

      // INJECT SLIDES
      fallback.forEach(p => {
        slider.insertAdjacentHTML(
          "beforeend",
          `
            <div class="slide">
              <a href="${p.link}" class="single-featured-box">
                <div class="content-image">
                  <img src="${p.image}" alt="${p.title}">
                </div>
                <div class="content-text text-white">
                  <h3 class="heading text-white">${p.title}</h3>
                  <p>${p.description || ""}</p>
                  <ul>
                    ${p.architect ? `<li><span>Architect - ${p.architect}</span></li>` : ""}
                    ${p.builder ? `<li><span>Builder - ${p.builder}</span></li>` : ""}
                    ${p.interior ? `<li><span>Interior Design - ${p.interior}</span></li>` : ""}
                    ${p.structural ? `<li><span>Structural Engineers - ${p.structural}</span></li>` : ""}
                    ${p.photography ? `<li><span>Photography - ${p.photography}</span></li>` : ""}
                  </ul>
                </div>
              </a>
            </div>
          `
        );
      });

      if (typeof $ !== "undefined") {
        setTimeout(() => {

          if ($(".three-column-slider").hasClass("slick-initialized")) {
            console.log("Refreshing existing slick...");
            $(".three-column-slider").slick("unslick");
          }

          console.log("Initializing slick...");
          $('.three-column-slider').slick({
              dots: false,
              arrows: false,
              infinite: false,
              speed: 300,
              slidesToShow: 3,
              slidesToScroll: 1,
              centerMode: false,
              autoplay: false,
              responsive: [

                  {
                      breakpoint: 750,
                      settings: {
                          slidesToShow: 2,
                          autoplay: true,
                          infinite: true
                      }
                  },
                  {
                      breakpoint: 600,
                      settings: {
                          slidesToShow: 2,
                          autoplay: true,
                          infinite: true
                      }
                  },
                  {
                      breakpoint: 480,
                      settings: {
                          slidesToShow: 1,
                          autoplay: true,
                          infinite: true
                      }
                  }

                ]
          });

        }, 200);
      }
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-project-listing"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {

  const grid = document.querySelector('.project-grid');
  const loadMoreBtn = document.querySelector('.load-more-projects');
  const filterLinks = document.querySelectorAll('.featured-project-menu a');
  const sortSelect = document.getElementById('casetype');

  let items = Array.from(document.querySelectorAll('.project-item'));

  items.forEach((item, index) => {
    item.dataset.index = index;
  });

  let visibleCount = 6;
  const increment = 6;

  let activeFilter = 'all';
  let activeSort = 'common'; 

  if (sortSelect) sortSelect.value = 'common';

  function getTitle(item) {
    return (
      item.querySelector('.heading')?.innerText.trim().toLowerCase() || ''
    );
  }

  function getFilteredItems() {
    if (activeFilter === 'all') return [...items];
    return items.filter(item => item.classList.contains(activeFilter));
  }

  function applySort(list) {
    let sorted = [...list];

    if (activeSort === 'common') {
      sorted.sort((a, b) => getTitle(a).localeCompare(getTitle(b)));
    }

    if (activeSort === 'newest') {
      sorted.sort((a, b) => b.dataset.index - a.dataset.index);
    }

    if (activeSort === 'popular') {
      sorted.sort(
        (a, b) => (b.dataset.popular || 0) - (a.dataset.popular || 0)
      );
    }

    return sorted;
  }

  function render() {
    let list = getFilteredItems();
    list = applySort(list);

    grid.innerHTML = '';
    list.forEach(item => grid.appendChild(item));

    list.forEach((item, i) => {
      item.style.display = i < visibleCount ? 'block' : 'none';
    });

    if (loadMoreBtn) {
      loadMoreBtn.style.display =
        list.length > visibleCount ? 'inline-block' : 'none';
    }
  }

  render();

  if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', () => {
      visibleCount += increment;
      render();
    });
  }

  filterLinks.forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault();

      filterLinks.forEach(l => l.classList.remove('active'));
      link.classList.add('active');

      activeFilter = link.dataset.filter;
      visibleCount = 6;
      render();
    });
  });

  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      activeSort = sortSelect.value;
      visibleCount = 6;
      render();
    });
  }

});

  } catch(e) { console.error(e); }
})();
})();
